import { render, staticRenderFns } from "./122.vue?vue&type=template&id=77005010&"
import script from "./122.vue?vue&type=script&lang=js&"
export * from "./122.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports